module.exports = __webpack_public_path__ + "img/reward-faild-emoji.1818352b.png";